// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rUioJ","delete":"styles_delete__1XH4z","update":"styles_update__oM7ke","add":"styles_add__1yeqY"};